export * from './balance-of-contract-approval.component';